<template>
    <label
        :class="[ isDisabled ? 'cursor-not-allowed opacity-40': 'cursor-pointer', isChecked ? 'bg-black text-white' : 'bg-white text-black' ]"
        class="rounded-sm border border-gray-light min-w-[55px] h-11 px-3 flex justify-center items-center text-center font-bold text-base"
        :disabled="isDisabled"
        :data-value="inputValue"
    >
        <input
            @change="valueChange"
            type="radio"
            :name="inputName"
            :value="inputValue"
            :disabled="isDisabled"
            class="w-0 h-0"
        >

        {{ inputLabel }}
    </label>
</template>

<script>
    export default {
        props: {
            isDisabled: {
                type: Boolean,
                default: false,
            },
            selectedValue: {
                type: String,
                required: true,
            },
            inputName: {
                type: String,
                required: true,
            },
            inputValue: {
                type: String,
                required: true,
            },
            inputLabel: {
                type: String,
                required: true,
            },
        },

        computed: {
            isChecked() {
                return this.selectedValue === this.inputValue;
            },
        },

        methods: {
            valueChange(event) {
                this.$emit('valueChange', event.srcElement.value);
            },
        },
    };
</script>
